import style from './Register.module.css'
import PersonalForm from './PersonalForm'
import CloseBubbleIcon from '../../../assets/svgs/CloseBubble'

const Register = ({ handleAuth, setOpenAuth }) => {
  return (
    <div className={style.mainContainer}>
      <div className={style.container}>
        <div className={style.closeBubble} onClick={() => handleAuth()}>
          <CloseBubbleIcon />
        </div>
        <PersonalForm setOpenAuth={setOpenAuth} />
      </div>
    </div>
  )
}

export default Register
